import React, { Component } from "react";
import logo from "../../images/confia-logo.svg";

class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rtdpj: props.rtdpj,
      showCartorio: props.show,
      footerMessage: props.footerMessage,
    };
  }

  render() {
    return (
      <>
        <div className="d-flex flex-column justify-content-center align-items-center mt-2">
          {/* {this.state.rtdpj && (
            <div>
              <span>
                <p className="fw-normal fs-6" style={{ color: "#585856" }}>
                  {this.state.footerMessage}
                </p>
              </span>
            </div>
          )} */}
          <div>
            <span className="fw-normal pb-2 d-flex flex-column justify-content-center" style={{ fontSize: "12px" }}>
              <p>
                Powered by <img src={logo} height={28} />
              </p>
            </span>
          </div>
        </div>
      </>
    );
  }
}

export default Footer;
